export const writeApiPathToLocaleStore = (apiServerPro, apiIdentity, gstaUrl) => {
  localStorage.setItem("urls", JSON.stringify({ apiServerPro, apiIdentity, gstaUrl }));
}

export const getApiIdentityPath = () => {
  const urls = JSON.parse(localStorage.getItem("urls"))
  return urls.apiIdentity
}

export const getApiServerProPath = () => {
  const urls = JSON.parse(localStorage.getItem("urls"))
  return urls.apiServerPro
}

export const getGstaUrl = () => {
  const urls = JSON.parse(localStorage.getItem("urls"))
  return urls.gstaUrl
}